// Contrôleur Stimulus pour l'édition des quantités des items de ticket
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { delay: { type: Number, default: 800 } }

  connect() {
    this.originalValue = this.inputTarget.value
    this.submitTimeout = null
  }

  disconnect() {
    if (this.submitTimeout) {
      clearTimeout(this.submitTimeout)
    }
  }

  submit() {
    const newValue = this.inputTarget.value
    
    // Annuler le timeout précédent s'il existe
    if (this.submitTimeout) {
      clearTimeout(this.submitTimeout)
    }
    
    // Ne soumettre que si la valeur a changé
    if (newValue !== this.originalValue) {
      // Valider la valeur avant soumission
      if (this.isValidQuantity(newValue)) {
        // Ajouter un délai avant de soumettre
        this.submitTimeout = setTimeout(() => {
          this.element.requestSubmit()
          this.originalValue = newValue
          this.submitTimeout = null
        }, this.delayValue)
      } else {
        // Restaurer la valeur originale si invalide
        this.inputTarget.value = this.originalValue
        this.showError("La quantité doit être un nombre positif")
      }
    }
  }

  handleResponse(event) {
    const response = event.detail.fetchResponse.response
    
    // Annuler le timeout en cours si la réponse arrive
    if (this.submitTimeout) {
      clearTimeout(this.submitTimeout)
      this.submitTimeout = null
    }
    
    if (!response.ok) {
      // En cas d'erreur, restaurer la valeur originale
      this.inputTarget.value = this.originalValue
    } else {
      // Mettre à jour la valeur originale si succès
      this.originalValue = this.inputTarget.value
    }
  }

  isValidQuantity(value) {
    const num = parseInt(value, 10)
    return !isNaN(num) && num > 0 && num <= 999
  }

  showError(message) {
    // Ajouter un feedback visuel temporaire
    const input = this.inputTarget
    const originalClass = input.className
    
    input.className = input.className.replace('border-gray-300', 'border-red-500')
    input.title = message
    
    setTimeout(() => {
      input.className = originalClass
      input.title = ""
    }, 2000)
  }
}
